<template>
    <tr v-if="renderByLabel">
        <td class="editor-content editor-label">{{ label }}</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.style.color">
                <option>dark</option>
                <option>light</option>
                <option>primary</option>
                <option>secondary</option>
                <option>success</option>
                <option>danger</option>
                <option>info</option>
                <option>warning</option>
                <option v-if="isCustomColor">{{selectedComponent.style.color}}</option>
                <option v-if="supportsCustomColor">custom</option>
            </select>
        </td>
    </tr>
    <tr v-else-if="isBorder">
        <td class="editor-content editor-label">Color</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.border.color">
                <option>dark</option>
                <option>light</option>
                <option>primary</option>
                <option>secondary</option>
                <option>success</option>
                <option>danger</option>
                <option>info</option>
                <option>warning</option>
                <option v-if="isCustomBorderColor">{{selectedComponent.border.color}}</option>
                <option>custom</option>
            </select>
        </td>
    </tr>
    <tr v-else>
        <td class="editor-content editor-label">{{ label }}</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.style.backgroundColor">
                <option>dark</option>
                <option>light</option>
                <option>primary</option>
                <option>secondary</option>
                <option>success</option>
                <option>danger</option>
                <option>info</option>
                <option>warning</option>
                <option v-if="isCustomBackgroundColor">{{selectedComponent.style.backgroundColor}}</option>
                <option v-if="supportsCustomColor">custom</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'ContextColorEditor',
        props: ['selectedComponent', 'label'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            supportsCustomColor() {
                return this.selectedComponent.type === 'Label' || this.selectedComponent.type === 'Header' || 
                    this.selectedComponent.type === 'Icon' || this.selectedComponent.type === 'Link' ||
                    this.selectedComponent.type === 'Button' || this.selectedComponent.type === 'Text'
            },
            isCustomColor() {
                return this.selectedComponent.style.color && this.selectedComponent.style.color.indexOf('#') === 0
            },
            isCustomBorderColor() {
                return this.selectedComponent.border.color && this.selectedComponent.border.color.indexOf('#') === 0
            },
            isCustomBackgroundColor() {
                return this.selectedComponent.style.backgroundColor && this.selectedComponent.style.backgroundColor.indexOf('#') === 0
            },
            renderByLabel() {
                return this.label === 'Color'
            },
            isBorder() {
                return this.label === 'Border Color'
            }
        }
    }
</script>

<style>

</style>
